import { render } from "./rulesSet.vue?vue&type=template&id=242cddc9&scoped=true"
import script from "./rulesSet.vue?vue&type=script&lang=js"
export * from "./rulesSet.vue?vue&type=script&lang=js"

import "./rulesSet.vue?vue&type=style&index=0&id=242cddc9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-242cddc9"]])

export default __exports__